import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/services/certification/page.tsx");
